module.exports = __webpack_public_path__ + "img/SS-Folgore.6f971f8e.png";